import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-arrow-from-top-icon',
  templateUrl: './navigation-arrow-from-top.component.html'
})
export class NavigationArrowFromTopComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
